import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { OwnService } from '../services/owners/own.service';
import { DialogOwner } from '../dialog/owners/dialog.component.own';
import { ListService } from '../list.service';
import { saveAs } from 'file-saver';

import { IOwner, IOwnerResponse } from './owners.interfaces';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-owners',
  templateUrl: './owners.component.html',
  styleUrls: [ './owners.component.css' ],
  providers: [ OwnService, ListService ]
})
export class OwnersComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public ownerData: IOwnerResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private ownModel: IOwner = {
      'id': 'NEW',
      'type': '',
      'name': '',
      'adress': '',
      'start_date': ''
     };
  public error: string = '';
  public showDialog: boolean = false;
  public editOwnerData: IOwner;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addOwner(): void {
    this.editOwnerData = Object.assign( {}, this.ownModel, { id : 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogOwner, {disableClose: true, height: '550px', data: {dades: this.editOwnerData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editOwnerData = results;
      this.addOrUpdate();
    });
  }

  public editOwner(owner: IOwner): void {
    this.editOwnerData = Object.assign( {}, this.ownModel, owner );
    let dialogFactRef=this.dialog.open(DialogOwner, {height: '550px', data: {dades: this.editOwnerData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editOwnerData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editOwnerData.id === 'NEW') {
      this.ownService.create(this.editOwnerData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");this.router.navigate(['owners']);});
    } else {
      this.ownService.update(<number> this.editOwnerData.id, this.editOwnerData)
        .subscribe(updatedContacte => {console.log("S'han desat les dades");this.router.navigate(['owners']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.ownerData.rows.find(item => item.id == this.editOwnerData.id);
        let index = this.ownerData.rows.indexOf(updateItem);
        this.ownerData.rows[index] = this.editOwnerData;
    }
  }

  public gotoPage(page: number): void {
    this.listOwnerService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listOwnerService.currentPage * this.listOwnerService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listOwnerService.currentPage * this.listOwnerService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listOwnerService.rowsPerPage - 1, this.ownerData.registers);
  }

  private requestRowsToParent(): void {
    this.ownService.getList(
      this.listOwnerService.rowsPerPage, //Limit
      this.listOwnerService.currentPage*this.listOwnerService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DE LS PROPIETARIS QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DELS PROPIETARIS QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.ownerData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listOwnerService.currentPage = Math.max(0, this.listOwnerService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listOwnerService.currentPage = this.listOwnerService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listOwnerService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public ownersFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public tokenStorage: TokenStorageService, public listOwnerService: ListService, public dialog:MatDialog, private ownService: OwnService, private router: Router, private route: ActivatedRoute) {
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.ordreCamps = ['id'];

    this.tableFields = [
      ['id', 'Id'],
      ['name', 'Name'],
      ['type', 'Type'],
      ['adress', 'Adress'],
      ['start_date', 'Start date']
    ];

    this.ownersFilters = [
    {
      inputs: []
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
              {
                text: 'Id',//Text a mostrar label
                name: 'id',//Camp de la base de dades
                autocomplete: 'id',//Crida per obtenir els valors si autocomplete
                value: this.listOwnerService.getSearchValues('text')//valor a mostrar
              },
              {
                text: 'Name',
                name: 'name',
                autocomplete: 'name',
                value: this.listOwnerService.getSearchValues('text')
              },
              {
                text: 'Type',
                name: 'type',
                autocomplete: 'type',
                value: this.listOwnerService.getSearchValues('text')
              }
          ]
        }
      ]
    }
  ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    ['id'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
 
    const id = this.route.snapshot.paramMap.get('id');
    
    if (id) {
      this.computeActiveFilters({ id: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
  }

  go(lloc, id?){if (id) {
    this.router.navigate([lloc, id]);
  } else {
    this.router.navigate([lloc]); // Navega només al lloc base si no hi ha ID
  }}

}
